import React, { useEffect, useState, useRef } from "react";
import slideshowStyle from './style';


function BackgroundSlideShow(props){
    let style = slideshowStyle();
    let images = props.images;
    let slideIndex = 1;
    let refArray = [];

    useEffect(() => {
        let intervalID = setInterval(() => {
            runSlideShow(images);
        }, 10000);
        return(() => {
            clearInterval(intervalID);
        });
    }, []);

    images.forEach(() => {
        refArray.push(useRef(null));
    });
    return(
        <div
         style={style.outerStyle()}
        >
            {images.map(((bg, i) => (
                <img 
                 src={bg} 
                 className={(`slide-image ${i > 0 ? 'o-0' : ''}`)} 
                 style={style.backgroundImage()}
                 key={i}
                 ref={refArray[i]}
                />
            )))}
            {props.children}
        </div>
    );

    //#region slideSlowFunctions
    function runSlideShow(images){
        updateSlide();
    }
    

    function updateSlide(){
        let currentRef = getCurrentRef();

        hideAllEles(images);

        style.fadeRefIn(currentRef);

        
        updateSlideIndex(images);
    }

    function getCurrentRef(){
        let ref = refArray[slideIndex];
        return ref;
    }

    function hideAllEles(images){
        for(let i = 0; i < images.length; i++){
            let selectedRef = refArray[i];
            style.fadeRefOut(selectedRef);
        }
    }
    function updateSlideIndex(images){
        if((slideIndex + 1) < images.length){
            slideIndex = slideIndex + 1;
        }
        else{
            slideIndex = 0;
        }
    }
    //#endregion
}

export default BackgroundSlideShow;